<template lang="html">
  <div class="login-dialog-form p-0 p-sm-3">
    <p class="login-text text-center">Iniciá sesión con email y contraseña</p>
    <form class="" method="post" @submit.prevent="submitForm">
      <div class="form-group">
        <label class="login-text" for="email">Email</label>
        <input
          @focus="handleFocus"
          id="email"
          type="email"
          v-model="username"
          class="form-control"
          placeholder="Ej: minombre@correo.com">
      </div>
      <div class="form-group">
        <label class="login-text" for="password">Password</label>
        <input
          @focus="handleFocus"
          id="password"
          type="password"
          v-model="password"
          class="form-control"
          placeholder="Por favor ingresá tu contraseña">
        <template v-if="errors.username" v-for="(error, index) in errors.username">
          <p :key="index" class="text-danger login-text-small mt-1">{{ error }}</p>
        </template>
        <template v-if="errors.password" v-for="(error, index) in errors.password">
          <p :key="index" class="text-danger login-text-small mt-1">{{ error }}</p>
        </template>
      </div>
      <div class="p-3">
        <SquaredButton
          :isWaiting="isFetching"
          :disabled="!username || !password || isFetching"
          type="submit"
          styleType="primaryLargeBlock"
          label="INGRESAR" />
      </div>
      <div class="row p-2">
        <div class="col-12 col-sm-6 text-center text-sm-left py-2 p-sm-0"
             @click="$emit('close')">
          <router-link
            class="login-text-small text-secondary"
            :to="{ name: 'register', params: {} }">
            <b>Creá tu cuenta</b>
          </router-link>
        </div>
        <div class="col-12 col-sm-6 text-center text-sm-right pt-2 p-sm-0">
          <a @click.prevent="resetPassword" class="login-text-small text-secondary" href="#">
            <b>¿Olvidaste tu contraseña?</b>
          </a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import store from '@/store'
import {instance as componentDialog} from '@/components/layout/ComponentDialog'
import EmailForm from '@/components/user/EmailForm'
import CodeForm from '@/components/user/CodeForm'
import SelectRecoveryMethodForm from "@/components/user/SelectRecoveryMethodForm.vue";

export default {
  data: () => ({
    username: null,
    password: null,
    isFetching: false,
    errors: {}
  }),

  methods: {
    submitForm () {
      document.activeElement.blur()
      this.isFetching = true

      const formData = {
        username: this.username,
        password: this.password
      }

      store.dispatch('user/login', formData)
        .then(res => {
          if (res) this.$emit('logged')
          this.pushToDataLayer('Login dialog', 'Login email')
        })
        .catch(this.handleErrors)
        .finally(() => { this.isFetching = false })
    },

    handleErrors (err) {
      this.errors = err instanceof Error
        ? { password: {error: err.message} }
        : err
    },

    handleFocus () {
      this.errors = {}
    },

    // resetPassword () {
    //   this.$emit('close')
    //   componentDialog({
    //     component: EmailForm,
    //     header: 'Reinicio de contraseña'
    //   })
    // },

    resetPassword () {
      this.$emit('close')
      componentDialog({
        component: SelectRecoveryMethodForm,
        header: 'Reinicio de contraseña',
        then: this.handleSelectedMethod
      })
    },

    handleSelectedMethod (method) {
      if (method === 'email') {
        this.openEmailForm()
      } else if (method === 'code') {
        this.openCodeForm()
      }
    },

    openEmailForm () {
      componentDialog({
        component: EmailForm,
        header: 'Reinicio de contraseña'
      })
    },

    openCodeForm () {
      componentDialog({
        component: CodeForm,
        header: 'Reinicio de contraseña'
      })
    }

  }
}
</script>

<style lang="css">
.login-text-small {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/LoginDialogForm.vue